// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1dyln","content":"styles_content__1Dnow","selectAll":"styles_selectAll__kLAyp"};